<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel d-flex flex-column w-85pc">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ 'label_Step' | translate}} 4{{"colon" | translate}} {{ "expense_category_wizard_step4_desc" | translate }}</h2>
                <app-video-icon [VideoUrl]="videoLink | safeUrl"></app-video-icon>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-primary mr-2" (click)="fnShowAddGradePanel(null,false,false)">
                    {{ 'grade_add' | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ "close" | translate }}
                </button>
            </div>
        </header>
        <div class="block mt-2 heightCalc-5">
            <div class="heightCalc-14">
                 <!----------------------Start Grid--------------------------->
                    <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"
                        [gridFilterItems]="gridFilterItems" (onCellClick)="fnOnGridCellClick($event)">
                    </app-grid>
                <!----------------------End Grid--------------------------->
            </div>
        </div>
    </div>
</div>
<!----------------------Side Panels--------------------------->
<grade-assign-category-panel [hidden]="!showCategoryAssignmentPanel" [selectedGrade]="currentEditingGrade"
    [categoriesList]="expenseCategories" (closePanel)="fnCloseAssignCategoryPanel($event)">
</grade-assign-category-panel>

<app-claimant-details-component *ngIf="showClaimantPanel" [lstClaimants]="lstClaimants" [panelHeader]="panelHeader"
  (callbackEvent)="fnPanelReceiver()"></app-claimant-details-component>

<add-grade-panel *ngIf="showAddGradePanel" [inputModel]="addGradePanelInputModel"
  (submitEvent)="fnSubmitAddGradePanel($event)" (closePanelEvent)="fnCloseAddGradePanel($event)"></add-grade-panel>